import { useEffect, useState } from 'react'
import { Trans, Plural, t } from '@lingui/macro'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'

type Props = {
  open: boolean
  initialSeconds: number
  onStay: () => void
}
export function IdleWarningDialog({ open, initialSeconds, onStay }: Props) {
  const [seconds, setSeconds] = useState(initialSeconds)

  useEffect(() => {
    if (!open) return
    setSeconds(initialSeconds)
    const id = setInterval(() => setSeconds((s) => (s <= 1 ? 0 : s - 1)), 1000)
    return () => clearInterval(id)
  }, [open, initialSeconds])

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Trans>You are about to be logged out</Trans>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          <Trans>
            For your security, you will be logged out in <strong>{seconds}</strong> <Plural value={seconds} one="second" other="seconds" /> due to inactivity.
            Click “Stay connected” to keep your session active.
          </Trans>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onStay}>
          <Trans>Stay connected</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  )
}
